import { gql, useQuery } from '@apollo/client';
import { currentRoomsVar } from './currentRooms';
export function useCurrentRooms() {
    const ROOMS_QUERY = gql `
        query Rooms {
            currentRooms @client {
                rooms {
                    boardOptionId
                    isConfirmed
                    price
                    pricePerPerson
                    wasPrice
                    wasPricePerPerson
                    roomTitle
                    boardTypeDescription
                    isSelected
                    isPreviouslySelected
                    hypeMessages {
                        title
                        type
                    }
                }
                selectedRoomIndex
                showPerPersonPrices
                soldOut
            }
        }
    `;
    const currentRoomState = useQuery(ROOMS_QUERY, { ssr: false });
    function setCurrentRoomState({ rooms, selectedRoomIndex, showPerPersonPrices, soldOut = false, }) {
        currentRoomsVar({
            rooms: rooms || [],
            selectedRoomIndex,
            showPerPersonPrices: showPerPersonPrices || false,
            soldOut,
        });
    }
    return [currentRoomState, setCurrentRoomState];
}
